<template>
  <div class="asc-report-table-cell--main-container">
    <template v-if="isDrill">
      <div :class="getContainerClass" @click="handleClick">
        <template
          v-if="isWarningAlert || isCautionAlert || isFaultMonitorAlert"
        >
          <asc-alert-item
            :status="reportCell.status"
            :value="reportCell.text"
          ></asc-alert-item>
        </template>
        <template v-else>
          <span :class="getTableCellClass">
            {{ getText }}
          </span>
        </template>
      </div>
    </template>
    <template v-if="!isDrill">
      <span>{{ getText }}</span>
    </template>
  </div>
</template>

<script>
import { AscReportMenuClickMixin } from '@/components/mixins'
import AscAlertItem from './AscAlertItem'
import * as constants from '@/utilities/appConsts'

export default {
  name: 'AscReportTableCell',

  components: {
    AscAlertItem,
  },

  mixins: [AscReportMenuClickMixin],

  props: {
    reportCell: {
      type: Object,
      required: true,
    },
    noMargins: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isWarningAlert() {
      if (this.reportCell && this.reportCell.status) {
        return (
          (this.reportCell.status === constants.STATUS_VALUES.lowWarning ||
            this.reportCell.status === constants.STATUS_VALUES.highWarning ||
            this.reportCell.status === constants.STATUS_VALUES.highLowWarning ||
            this.reportCell.status === constants.STATUS_VALUES.eventWarning) &&
          this.reportCell.alertEnabled === true
        )
      }
      return false
    },
    isCautionAlert() {
      if (this.reportCell && this.reportCell.status) {
        return (
          (this.reportCell.status === constants.STATUS_VALUES.lowCaution ||
            this.reportCell.status === constants.STATUS_VALUES.highCaution ||
            this.reportCell.status === constants.STATUS_VALUES.highLowCaution ||
            this.reportCell.status === constants.STATUS_VALUES.eventCaution) &&
          this.reportCell.alertEnabled === true
        )
      }
      return false
    },
    isFaultMonitorAlert() {
      return this.reportCell.status === constants.STATUS_VALUES.faultMonitor
    },
    getContainerClass() {
      return this.isWarningAlert || this.isCautionAlert || this.isFaultMonitor
        ? 'asc-report-table-cell--container-no-top-bottom-margins'
        : this.noMargins
        ? 'asc-report-table-cell--container-no-left-right-margins'
        : 'asc-report-table-cell--container'
    },
    isDrill() {
      return this.reportCell.parameterId !== null
    },
    getText() {
      return this.reportCell.text
    },
    isEmptyText() {
      return this.reportCell.text === ''
    },
    getTableCellClass() {
      return this.isEmptyText
        ? 'asc-report-table-cell--empty'
        : 'asc-report-table-cell'
    },
  },

  methods: {
    handleClick(event) {
      if (this.onReportMenuClick) {
        this.onReportMenuClick(event, this.reportCell)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-report-table-cell--main-container {
  & .asc-report-table-cell--container {
    padding: 0.5em;
    text-align: center;

    & .asc-report-table-cell {
      font-size: $font-size-sm;
    }
  }

  & .asc-report-table-cell--container-no-top-bottom-margins {
    padding: 0 0.5em;
    font-size: $font-size-sm;
  }

  & .asc-report-table-cell--container-no-left-right-margins {
    padding: 0;
    font-size: $font-size-md;
  }

  & .asc-report-table-cell--empty {
    color: $primary-white;
  }

  & .asc-alert-label {
    font-size: $font-size-sm;
  }
}
</style>
